import React from 'react';
import {formatNumber} from "../../../shared/Utility";

const statTableRow = props => {

  return (
    <tr className={"gradeA " + (props.isOdd ? 'odd' : 'even')} role="row">
      <td className="sorting_1">
        <img src={props.rowStats.countryInfo.flag} height="15em"/> {props.rowStats.country}
      </td>
      <td>{formatNumber(props.rowStats.cases)}</td>
      <td className={props.rowStats.yesterdayCases > 0 ? 'warning' : ''}>
        {formatNumber(props.rowStats.yesterdayCases)}</td>
      <td className={props.rowStats.todayCases > 0 ? 'warning' : ''}>
        {formatNumber(props.rowStats.todayCases)}</td>
      <td>{formatNumber(props.rowStats.deaths)}</td>
      <td className={props.rowStats.yesterdayDeaths > 0 ? 'danger' : ''}>
        {formatNumber(props.rowStats.yesterdayDeaths)}</td>
      <td className={props.rowStats.todayDeaths > 0 ? 'danger' : ''}>
        {formatNumber(props.rowStats.todayDeaths)}</td>
      <td>{formatNumber(props.rowStats.recovered)}</td>
      <td>{formatNumber(props.rowStats.active)}</td>
      {/*<td>{props.rowStats.critical}</td>*/}
      <td>{formatNumber(props.rowStats.casesPerOneMillion)}</td>
      <td>{formatNumber(props.rowStats.deathsPerOneMillion)}</td>
    </tr>
  )
};

export default statTableRow;
